<template>
	<div id="app">
		<headBar ref='headerBarView' :url='url'/>
		<sideBar ref='sideBarView' :url='url'/>
		<router-view 
		@jump-to-chat="jumpToChat" 
		@jump-to-profile="jumpToProfile"
		@send-message="sendMessage"
		@load-history="loadHistory"
		@user-login="userLogin"
		ref="archView"
		/>
	</div>
</template>

<script>
import headBar from '@/components/headBar.vue'
import sideBar from '@/components/sideBar.vue'

export default {
	name: "app",
	components:{
		headBar,
		sideBar
	},
    watch:{
        '$route' (to, from){
			if(this.$store.state.userStatus !== 'loggedin')this.$router.push({path:`/Login`,replace:true});
			this.$store.state.sideBarOpen=false;
			this.$store.state.chatPageModalOpen=false;
			this.$store.state.searchPageModalOpen=false;
		}
    }, 
	methods:{
		jumpToChat(targetCid){
			this.$router.push({path:`/chatPage/${targetCid}`,replace:true});
			// this.$router.go(1);
		},
		jumpToProfile(targetUid){
			this.$router.push({path:`/Profile/${targetUid}`,replace:true});
			// this.$router.go(1);
		},
		sendMessage(payload){
			this.$socket.emit('message', {message:payload.message,userName:payload.userName,cid:payload.cid,date:payload.date});
		},
		loadHistory(payload){
			this.$socket.emit('loadHistory',{cid:payload.cid,lastUpdateDatetime:payload.lastUpdateDatetime});
		},
		userLogin(payload){
			this.$socket.emit('clientAuth',{id:payload.id,password:payload.password,groupRecap:(payload.groupRecap)?payload.groupRecap:null});
		}			
	},
	sockets: {
		loginAuth: function(){
			// console.log('loginAuth');
			if(this.$store.state.userStatus==='loggedin' && this.$store.state.userMail !=='' && this.$store.state.userPasswd !==''){
				let need2Recap=false;
				let ChatLog=[];
				if(this.$store.state.chats){
					need2Recap=true;
					let count=0;
					while(this.$store.state.chats[count]){
						let perChat={};
						perChat.cid=this.$store.state.chats[count].cid;
						perChat.lastUpdateDatetime=this.$store.state.chats[count].lastUpdateDatetime;
						ChatLog.push(perChat);
						count++;
					}
				}
				this.userLogin({id:this.$store.state.userMail,password:this.$store.state.userPasswd,groupRecap:(need2Recap)?ChatLog:null});
			}else{
				this.$router.push({path:`/Login`,replace:true});
				// this.$router.go(1);
			}
		},
		userAuth:function(payload){
			let isRefresh=(this.$store.state.userStatus === 'loggedin')?true:false;
			if(payload.result==='success'){
				this.$store.commit('changeUserStatus',{newStatus:'loggedin'});
				this.$store.commit('login',{userName:payload.userName,UID:payload.UID});
				this.$store.commit('initContacts',{index:payload.contacts});
				// console.log('login success');
				if(isRefresh) this.$store.commit('refresh',{group:payload.joinedGroups,contact:payload.contacts});
				if(this.$route.name === 'login'){
					this.$router.push({path:`/home`,replace:true});
				}
				// this.$router.go(1);
			}else if(payload.result==='failure'){
				this.$store.commit('changeUserStatus',{newStatus:'offline'});
				this.$store.commit('logout');
				// console.log('login failure');
				if(this.$route.name === 'login'){
					alert('fail to login, please check your mail or password!');
				}
				this.$router.push({path:`/Login`,replace:true});
				// this.$router.go(1);
			}
		},
		group:function(payload){
			this.$store.commit('updateGroup',payload);
		},
		loadHistoryBack:function(payload){
			let needToAdd=false;
			if(this.$route.name ==='chatPage'){
				// console.log('loadback count try '+typeof this.$route.params.cid+" "+typeof payload[0].cid);
				if(parseInt(this.$route.params.cid) !== payload[0].cid){
					needToAdd=true;
				}
			}else{
				needToAdd=true;
			}
			if(needToAdd){
				// alert('loadback count change!');
				this.$store.commit('updateMsgCount',{cid:payload[0].cid,addCount:payload.length});
			}
			this.$store.commit('syncHistory',payload);
		},
		newMessage:function(payload){
			let needToAdd=false;
			if(this.$route.name === 'chatPage'){
				if(parseInt(this.$route.params.cid) !== parseInt(payload.cid)){
					needToAdd=true;
				}else{
					this.$refs.archView.pullHistory();
				}
			}else{
				needToAdd=true;
			}
			if(needToAdd){
				// alert('count change!');
				this.$store.commit('updateMsgCount',{cid:payload.cid,addCount:1});
			}
			this.$store.commit('updateLastestMessage',payload);
		},
		loadContactsBack:function(payload){
			this.$store.commit('initContacts',{contacts:payload});
		},
		groupActionBack:function(payload){
			switch(payload.action){
				case 'join':
					if(!payload.error){
						this.$store.commit('updateGroup',[payload.groupInfo]);
					}
					break;
				case 'leave':
					if(!payload.error){
						this.$store.commit('deleteGroup',{cid:payload.cid});
					}
					break;
				case 'create':
					if(!payload.error){
						this.$store.commit('updateGroup',[payload.groupInfo]);
						if(this.$route.name === 'searchPage')this.$router.push({path:`/home`,replace:true});
					}
					break;
				case 'checkin':
					if(!payload.error){
						if(this.$route.name === 'searchPage' || this.$route.name === 'chatPage')alert('check in successfully');
						this.$store.commit('updateCheckin',{cid:payload.cid,checkin:payload.checkin});
					}else{
						if(this.$route.name === 'searchPage' || this.$route.name === 'chatPage')alert('fail to check in!');
					}
					break;
				default:
					console.log('unsupported action');
			}
		},
		contactActionBack:function(payload){
			switch(payload.action){
				case 'add':
					if(!payload.error){
						this.$store.commit('addContacts',{userInfo:payload.userInfo});
					}
					break;
				case 'delete':
					if(!payload.error){
						this.$store.commit('deleteContact',{uid:payload.targetUid});
						if(payload.cid)this.$store.commit('deleteGroup',{cid:payload.cid});
					}
					break;
				default:
					console.log('unsupported action');
			}
		},
		initChatBack:function(payload){
			if(payload.groupInfo) this.$store.commit('updateGroup',[payload.groupInfo]);
			if(payload.needToListen) this.$socket.emit('groupAction',{action:'listen',cid:payload.groupInfo.cid});
			if((this.$route.name === 'profile' && parseInt(this.$route.params.uid) === payload.targetUid && !payload.needToListen) || this.$route.name === 'searchPage'){
				this.$router.push({path:`/chatPage/${payload.cid}`,replace:true});
			}
		},
		sendMsgBack:function(payload){
			this.$store.commit('confirmSend',payload);
		}
	},
	computed:{
        url(){
            return this.$store.state.baseUrl+'/userPic/'+this.$store.state.UID
        }
	},
	mounted(){
		if(this.$store.state.userStatus !== 'loggedin')this.$router.push({path:`/Login`,replace:true});
	}
}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	body {
		margin: 0;
		padding: 0;
		background-color:rgb(240, 239, 239);
	}

	.smooth-trans {
		transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
	}

	::-webkit-scrollbar {
		display:none;
	}

	p {
		margin:0;
	}

	.main-content {
		padding-top: 64px;
		width: 100vw;
		display: flex;
		flex-direction: column;
	}

	.hide {
		display: none !important;
	}

	.unSelectable {
		-webkit-user-select: none;  /* Chrome all / Safari all */
		-moz-user-select: none;     /* Firefox all */
		-ms-user-select: none;      /* IE 10+ */
		user-select: none;          /* Likely future */   
	}

    .modal-card {
        background-color: #fefefe;
        margin: 15% auto;
        padding: 20px;
        border: 1px solid #888;
        width: 80%; 
        display: flex;
        flex-direction: column;
        align-items:center;
        animation-name: reveal-card;
        animation-duration: 0.4s;
    }

    @keyframes reveal-card {
        from {margin-top: 1000px}
        to {margin-top: 15% auto;}
    }

	.inputfile {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

	a:link {color: black; text-decoration:none;}   
	a:active{color: black; }
	a:visited {color:black;text-decoration:none;} 
	a:hover {color: black; text-decoration:none;} 
</style>
